import gql from 'graphql-tag';

export const FoodServiceListQuery = gql`
	query FoodServiceListQuery(
		$first: Int
		$cursor: String
		$orderBy: FoodServiceOrderBy
		$orderDesc: Boolean
		$filter: FoodServiceFilterInput
	) {
		entities: foodServices(
			first: $first
			after: $cursor
			orderBy: $orderBy
			orderDesc: $orderDesc
			filter: $filter
		) {
			edges {
				node {
					id
					localId
					name
					dimension
					type
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;
